const dateLocale = require('date-fns/locale/es');

export default {
  dateLocale,
};
